import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Mousewheel, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import ReviewPreviewAPI from "../api/ReviewPreviewAPI";

const ReviewPreview = () => {
  const [reviewInfo, setReviewInfo] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await ReviewPreviewAPI.getReviewPreview();
        setReviewInfo(res.data);
      } catch (err) {
        console.error("Error:", err);
      }
    };
    fetchData();
  }, []);

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    const stars = [];
    for (let i = 0; i < fullStars; i++) {
      stars.push(<i className="bi bi-star-fill" key={`f${i}`} style={{ color: "#f36d21" }}></i>);
    }
    if (hasHalfStar) {
      stars.push(<i className="bi bi-star-half" key="half" style={{ color: "#f36d21" }}></i>);
    }
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<i className="bi bi-star text-secondary" key={`e${i}`}></i>);
    }
    return stars;
  };

  const toggleExpand = (id, e) => {
    e.stopPropagation(); // Prevent card click from triggering
    setExpandedIds((prev) => {
      const isExpanding = !prev.includes(id);

      setTimeout(() => {
        swiperRef.current?.swiper?.update();
      }, 0);

      return isExpanding ? [...prev, id] : prev.filter((i) => i !== id);
    });
  };

  // ✅ Card ke bahar click pe collapse karo
  const handleCardClick = (id) => {
    if (expandedIds.includes(id)) {
      setExpandedIds((prev) => prev.filter((i) => i !== id));
      setTimeout(() => {
        swiperRef.current?.swiper?.update();
      }, 0);
    }
  };

  // ✅ Document pe click listener for outside clicks
  useEffect(() => {
    const handleOutsideClick = () => {
      if (expandedIds.length > 0) {
        setExpandedIds([]);
        setTimeout(() => {
          swiperRef.current?.swiper?.update();
        }, 0);
      }
    };

    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [expandedIds]);

  return (
    <section className="custom-review-preview border" style={{ backgroundColor: "#fafafa" }}>
      <div className="container-fluid pb-5 text-center" style={{ backgroundColor: "#fafafa" }}>
        <h1
          className=" fs-3 w-100 fw-bold d-inline-block pt-4 mb-4"
          style={{ color: "#249acd", borderBottom: "4px solid #249acd" }}
        >
          Reviews
        </h1>

        <Swiper
          ref={swiperRef}
          className="pt-5 px-2 custom-review-preview-swiper-slider-cont"
          spaceBetween={30}
          freeMode={true}
          loop={true}
          allowTouchMove={true}
          direction="horizontal"
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          mousewheel={{ forceToAxis: true }}
          modules={[Autoplay, FreeMode, Pagination, Mousewheel]}
          breakpoints={{
            320: { slidesPerView: 1, spaceBetween: 10 },
            375: { slidesPerView: 1, spaceBetween: 12 },
            425: { slidesPerView: 1, spaceBetween: 15 },
            640: { slidesPerView: 2, spaceBetween: 20 },
            768: { slidesPerView: 2, spaceBetween: 10 },
            1024: { slidesPerView: 2, spaceBetween: 20 },
            1440: { slidesPerView: 3, spaceBetween: 20 },
          }}
        >
          {reviewInfo.map((review) => {
            const { id, review_title, images, review_text, rating } = review;
            const isExpanded = expandedIds.includes(id);

            return (
              <SwiperSlide
                key={id}
                className="custom-review-preview-swiper-slider"
              >
                <div
                  className="card custom-review-preview-card shadow-sm rounded-4 overflow-hidden"
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                >
                  <div className="custom-review-card-img">
                    <img src={images} alt={review_title} />
                  </div>
                  <div className="custom-review-preview-card-body card-body">
                    <h5 className="card-title d-flex justify-content-between align-items-center">
                      <div className="container-fluid">
                        <div className="row py-2">
                          <span className="col-6 custom-review-preview-review-title">
                            {review_title}
                          </span>
                          <span className="custom-review-preview-rating text-warning col-6">
                            {renderStars(rating)}
                          </span>
                        </div>
                      </div>
                    </h5>

                    <p
                      className={`custom-review-preview-card-text text-muted ${isExpanded ? "expanded" : "collapsed"
                        }`}
                    >
                      {review_text}
                    </p>

                    {review_text.length > 150 && (
                      <button
                        className="btn btn-link p-0"
                        style={{ fontSize: "0.85rem", color: "#249acd" }}
                        onClick={(e) => toggleExpand(id, e)}
                      >
                        {isExpanded ? "Read Less" : "Read More"}
                      </button>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default ReviewPreview;